document.addEventListener("DOMContentLoaded",function(){


const customBtn=document.getElementById("openCustomize")

const customPopup=document.getElementById("customizePopup")


customBtn.onclick=()=>customPopup.style.display="flex"

document.querySelectorAll(".closePopup").forEach(btn=>{
btn.onclick=()=>{

customPopup.style.display="none"
}
})

let step = 0
const materialSteps = materialPopup.querySelectorAll(".wizard-step")


function showStep(){

materialSteps.forEach((s,i)=>{
s.classList.toggle("active",i===step)
})

}

document.getElementById("nextStep").onclick=()=>{
if(step < materialSteps.length - 1){
step++
showStep()
}
}

document.getElementById("prevStep").onclick=()=>{
if(step>0){
step--
showStep()
}
}

showStep()

const sizeSelect=document.getElementById("sizeSelect")
const measurements=document.getElementById("measurements")

if(sizeSelect){

sizeSelect.onchange=()=>{
if(sizeSelect.value){
measurements.style.display="none"
}else{
measurements.style.display="block"
}
}

}

})
const form = document.querySelector("form[action*='/cart/add']");
const addToCartBtn = form.querySelector("button[type='submit']");

function validateSelections(){

  const groups = {};

  // collect all radio groups
  popup.querySelectorAll("input[type='radio']").forEach(input=>{
    groups[input.name] = true;
  });

  let allSelected = true;

  // check all radio groups
  Object.keys(groups).forEach(name=>{
    const checked = popup.querySelector(`input[name="${name}"]:checked`);
    if(!checked){
      allSelected = false;
    }
  });

  // 👉 SIZE LOGIC
  const sizeSelect = document.getElementById("standardSize");
  const measurements = popup.querySelectorAll("#measurementFields input");

  if(sizeSelect){

    if(sizeSelect.value){
      // ✅ Standard size selected → IGNORE measurements
      return allSelected;
    } else {
      // ❌ Custom → measurements REQUIRED
      let measurementsFilled = true;

      measurements.forEach(input=>{
        if(!input.value){
          measurementsFilled = false;
        }
      });

      return allSelected && measurementsFilled;
    }

  }

  return allSelected;
}
